/* The per-entry rate cell on Billing / Over Run (Stage 2 · 2.5): the rate the entry was logged at, else "Rate not set".
   RATE HISTORY VOID (owner 26-Oct-2026): an entry whose rate on its date was a voided (test) rate reads
   "Rate not set - test rate removed" (EN + AR) — its stored reason ``rate_voided``. */
export const RATE_VOIDED = "rate_voided";

export function entryRateText(e, t, money) {
  if (e.rate != null) return money(e.rate);
  return e.rate_reason === RATE_VOIDED ? `${t("dsBilling.rateNotSet")} - ${t("dsBilling.reason.rate_voided")}` : t("dsBilling.rateNotSet");
}
